import { getScanSitesService } from 'business/scan-site-settings/services/get-scan-sites';
import { useScanSiteV1ControllerGetByProject } from 'generated/apiComponents';
import type { Session } from 'technical/auth/client';
import { useNetworkStatus } from 'technical/network/use-network-status';
import { useOnlineOfflineQuery } from 'technical/online-offline';

export const useGetScanSitesQuery = (session: Session | null) => {
  const { isOnline } = useNetworkStatus();
  const useQueryResult = useScanSiteV1ControllerGetByProject(
    {
      queryParams: {
        projectId: session!.user.projectId,
      },
    },
    {
      enabled: isOnline && !!session?.user.projectId,
    },
  );

  return useOnlineOfflineQuery({
    useQueryResult,
    offlineService: getScanSitesService,
  });
};
